export default __webpack_public_path__ + "static/media/cf2.41d874e3.jpg";